import React from "react";
import { Modal } from "antd";
import { FilledButton, BorderedButton } from "../../commonComponents";
import "./InsufficientBalance.scss";

const InsufficientBalance = ({
  visible,
  closeModal,
  message,
  title = "Game join failed!",
  buttonLabel = "Cancel",
  // Extra class for the public join-screen popups ("cc-join-popup"); every
  // style that changes their look is scoped to it in InsufficientBalance.scss.
  popupClass = "",
}) => {
  return (
    <>
      <Modal
        open={visible}
        title={title}
        onCancel={closeModal}
        wrapClassName="depinsufficientbalanceositsuccess-modal"
        className={`insufficientbalance-modal-inner ${popupClass}`.trim()}
        footer={null}
        maskStyle={{
          backdropFilter: "blur(5px)",
        }}
      >
        <p style={{color:"white"}}>{message}</p>
        <div className="deposit-modal-buttons">
          <BorderedButton
            name={buttonLabel}
            btnClass="alert-buttons-discard"
            functionCall={closeModal}
          />
        </div>
      </Modal>
    </>
  );
};
export default InsufficientBalance;
